import React, { Component } from "react";
import {
  reduxForm,
  destroy,
  arrayPush,
  arrayRemove,
  arrayInsert,
  initialize,
  change,
} from "redux-form";
import { push } from "react-router-redux";
import { v4 as uuid } from "uuid";
import * as moment from "moment";
import { ReduxCheckbox as Checkbox } from "../../../../components/form/Checkbox";
import Input from "../../../../components/form/Input";
import Password from "../../../../components/form/Password";
import DatePicker from "../../../../components/form/DateTime";
import Button from "../../../../components/form/Button";
import DropdownButton from "../../../../components/form/DropdownButton";
import Select from "../../../../components/form/Select";
import CroMunicipality from "../../components/generalForm/CroMunicipality";
import CroCountry from "../../components/generalForm/CroCountry";
import CroField from "../../components/generalForm/CroField";
import CroSubhead from "../../components/generalForm/CroSubhead";
import CroLabeledCmp from "../../components/generalForm/CroLabeledCmp";
import WorkingPositionGrid, { WorkPositionGridWithOvmName, WorkPositionGridInternal } from "../../components/grids/WorkPositionGrid";
import {
  StatementGridOvm,
  StatementGridPublic,
  StatementGridInternal,
  StatementGridAllAdminForOfficialDetail,
  StatementGridRozpracovane,
  StatementGridRozpracovaneAllAdmin
} from "../../components/grids/StatementGrid";
import WorkingPositionAddForm from "../../components/forms/WorkingPositionAddForm";
import EsmEntriesSection from "../../components/forms/EsmEntriesSection";
import { styles } from "../../index";
import {
  isOvm,
  isNotLogged,
  isInternal,
  isPublic,
  isLogged,
  isLegitimate,
  isOfficialAdmin,
  isAdmin,
} from "../../CroUtils";
import {
  generateLogin,
  canPublicSeeStatement,
  deleteStatements,
  getCzechRepublic,
  getOrp,
  saveWorkingPosition,
  getFunctionaryNoticeTypes,
  createStatementInspectionResult,
  createWorkingPositionInspectionResult,
  getAdministrativeAuthorityOptions,
  generateHandoverProtocolOfficialWorkingPosition,
  getForwardingReasons,
  getStatementVersion,
  downloadStatementDigitalActCertificate,
  deleteWorkingPosition,
} from "../../CroActions";
import { dataInit, dataLoad, setItems } from "../../../../components/Grid/localActions";
import { Order } from "../../../../components/Grid/localProvider";
import fetch from "../../../../utils/fetch";
import { isNil, identity, get, debounce } from "lodash";
import {InspectionResult, Visibility, VisibilityRaw} from "../../enum";
import * as V from "../../../../utils/formValidation";
import askAction from "../AskAction";
import { noop } from "../../../../utils";
import { constructQuery } from "../../../../components/Grid/dataActions";
import H, { enumOnCondition } from "../../helpEnum";
import { setLoading, togglePanel } from "../../../../actions/appActions";
import OvmAutoComplete from "../OvmAutoComplete";
import ForwardingClarifyingDialog from "../ForwardingClarifyingDialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";

const WP_GRID_NAME = "workingPositionLocalGrid";
const minLength5 = V.minLength(5);
const minLength8 = V.minLength(8);

const FORM_NAME = "officialForm";

// Evidence skutečných majitelů se zatím nevyužívá – sekce je na FE skrytá,
// BE (endpointy /api/funkcionari/{id}/esm i číselník esm-funkce) zůstává funkční.
// Pro znovuzapnutí stačí přepnout na true.
const SHOW_ESM_SECTION = false;

class OfficialForm extends Component {
  state = {
    loading: true,
    publicCanSeeSatements: false,
    items: [], //dummy
    adoptedEmailPresent: false,
    showAddress: "",
    functionaryNoticeTypes: [],
    rozpracovaneCount: null,
    statementUpdatePending: false,
    workingPositionsUpdatePending: false,
    submitAfterGenerateLogin: false,
    shouldSave: false,
    loadingExistingOfficial: false,
    forwardingReasons: [],
    forwardingDialogOpen: false,
    forwardingSelectedReason: null,
    administrativeAutorities: null,
    infoDialog: { open: false, title: '', text: '' },
  };

  existingOfficialDebounced = null;

  async componentDidMount() {
    const {
      breadcrumbs,
      breadcrumbsItems,
      params,
      auth,
      dispatch,
      change,
      isNew,
      previousState,
    } = this.props;

    breadcrumbs(breadcrumbsItems);

    try {
      // javascript inak neda :O
      try {
        var formNotAlreadyFilled =
            typeof previousState === "undefined" ||
            previousState === undefined ||
            previousState === null ||
            previousState.form === undefined ||
            Object.keys(previousState.form).length === 0 ||
            Object.keys(previousState.form.officialForm).length === 0;
      } catch (TypeError) {
        formNotAlreadyFilled = true;
      }

      if (isOvm(auth)) {
        const response = await fetch("/podpurny-organ/api/profil/ja", dispatch);
        const data = await response.json();
        this.setState({displayDOSCheckbox: data.isDeputyOrSenator});
      }

      if (isLogged(auth) && isPublic(auth)) {
        const canSee = await canPublicSeeStatement(params.id, dispatch);
        this.setState({publicCanSeeSatements: canSee});
      }

      if (isNew && formNotAlreadyFilled) {
        getCzechRepublic(dispatch).then((result) => {
          change("birthAddress.country", result);
        });
      }

      if (isInternal(auth) && !isNew) {
        const functionaryNoticeTypes = await getFunctionaryNoticeTypes(dispatch);
        this.setState({functionaryNoticeTypes: functionaryNoticeTypes.items});

        const administrativeAutoritiesOptions = await getAdministrativeAuthorityOptions(auth.startUrl, params.id, dispatch);
        this.setState({administrativeAutorities: administrativeAutoritiesOptions.items});
      }

      if (isInternal(auth)) {
        const forwardingReasonsOptions = await getForwardingReasons(dispatch);
        this.setState({forwardingReasons: forwardingReasonsOptions.items || []});
      }

      if (isInternal(auth) && !isNew && this.props.canListStatements) {
        try {
          const response = await fetch(
              `${auth.startUrl}/api/funkcionari/${params.id}/oznameni/rozpracovane?page=0&pageSize=1`,
              dispatch,
          );
          const data = await response.json();
          this.setState({rozpracovaneCount: data.count || 0});
        } catch (e) {
          this.setState({rozpracovaneCount: 0});
        }
      }
    } finally {
      this.setState({ loading: false });
    }

    this.props.change("locked", this.props.locked);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.submitAfterGenerateLogin) {
      const { onSubmitWithoutRedirect } = this.props;
      
      try {
        this.save(onSubmitWithoutRedirect)();
      } finally {
        this.setState({ submitAfterGenerateLogin: false });
      }
    }
  }

  save = (handler) => {
    const { handleSubmit, onSubmit } = this.props;
    let targetHandler = handler;
    if (!targetHandler || targetHandler === onSubmit) {
      targetHandler = onSubmit;
    }
    return handleSubmit(targetHandler);
  };

  generateLogin = (data) => async () => {
    const { change, dispatch, isNew } = this.props;
    const { username, password } = await generateLogin(
      `${this.props.auth.startUrl}/api/funkcionari/prihlasovaci-udaje/generovat`,
      dispatch,
      data,
    );

    change("username", username);
    change("plainPassword", password);
    if(!isNew) {
      this.setState({ submitAfterGenerateLogin: true });
    }
  };

  existingOfficial = (field) => {
    if (!this.existingOfficialDebounced) {
      this.existingOfficialDebounced = debounce(
          async (fieldName, obj, newVal, oldVal) => {
            const existData = { ...this.props.existData, [fieldName]: newVal };
            const { dispatch } = this.props;

            if (existData.firstName && existData.lastName && existData.birthDate) {
              const firstNameFilter = {
                field: "firstName",
                operation: "CONTAINS",
                value: existData.firstName,
              };
              const lastNameFilter = {
                field: "lastName",
                operation: "CONTAINS",
                value: existData.lastName,
              };
              const birthFilter = {
                field: "birthDate",
                operation: "EQ",
                value: existData.birthDate.substring(0, 10),
              };

              const constructedQuery = constructQuery({
                filters: [firstNameFilter, lastNameFilter, birthFilter],
                sort: "created",
                order: "DESC",
                pageSize: 10,
                page: 0,
              });

              this.setState({ loadingExistingOfficial: true });
              dispatch(setLoading(true, "Načítání..."));

              try {
                const response = await fetch(
                    "/podpurny-organ/api/funkcionari/existing",
                    this.props.dispatch,
                    { params: constructedQuery },
                );
                const existing = await response.json();

                if (existing.count > 0) {
                  if (existing.count > 1) {
                    dispatch(togglePanel("Bylo nalezeno více veřejných funkcionářů se stejným jménem a datem narození. Zkontrolujte prosím, zda se jedná o správného funkcionáře."));
                  }

                  const existingOfficial = existing.items[0];
                  const processedOfficial = this.props.postProcess(existingOfficial);

                  // Check first name and birthdate equals form data
                  if (
                      processedOfficial.firstName.toLowerCase() ===
                      existData.firstName.toLowerCase() &&
                      processedOfficial.birthDate ===
                      existData.birthDate.substring(0, 10)
                  ) {
                    processedOfficial.originalWPs = get(
                        processedOfficial,
                        "workingPositions",
                        0,
                    );
                    this.props.initialize(processedOfficial);
                    this.props.lock(true);
                    this.props.change("locked", this.props.locked);
                    this.setState({
                      adoptedEmailPresent: !isNil(processedOfficial.email)
                          && String(processedOfficial.email).trim().length > 0,
                    });
                  }
                }
              } finally {
                this.setState({ loadingExistingOfficial: false });
                dispatch(setLoading());
              }
            }
          },
          1000,
      );
    }

    return (obj, newVal, oldVal) => {
      this.existingOfficialDebounced(field, obj, newVal, oldVal);
    };
  };

  onChangeDeathDate = (value) => {
    if (value) {
      this.openInfoDialog('Datum úmrtí', 'Zadáváte datum úmrtí, před pokračováním změnu uložte.');
    }
  }

  openInfoDialog = (title, text) => {
    this.setState({ infoDialog: { open: true, title, text } });
  }

  closeInfoDialog = () => {
    this.setState({ infoDialog: { open: false, title: '', text: '' } });
  }

  onKeyDown = (event) => {
    if (event.keyCode === 13) {
      this.save()();
    }
  };

  checkWPsForSenatorOrDeputy = () => {
    const workingPositions = this.props.workingPositions; //id senatu a poslanecke snemovny
    return workingPositions.some(
      (wp) =>
        wp.workingPosition.organization.id ===
          "6ab839a9-80e5-40fb-8b0e-740b9e54ef03" ||
        wp.workingPosition.organization.id ===
          "6836e473-3c1a-434a-b58d-6c2119c44984",
    );
  };

  disableGen = () => {
    const { firstName, lastName } = this.props.loginData;
    return !firstName || !lastName;
  };

  onRemoveStatements = async (ids) => {
    await deleteStatements(ids)(this.props.dispatch);
    this.setState({ items: [...this.state.items, 0] });
  };

  showAddress = async () => {
    const { getAddress, change, dispatch, postProcess } = this.props;

    const address = await getAddress();
    if (address !== null) {
      const orp = await getOrp(
        dispatch,
        get(address, "permanentAddress.municipalityId", ""),
      );
      if (orp !== "") {
        address.permanentAddress.orp = orp;
      }
      change("permanentAddress", postProcess(address).permanentAddress);
      change("permanentAddressUpdateDate", address.permanentAddressUpdateDate);
      change("deathDate", address.deathDate);
      this.setState({ showAddress: "address" });
    } else {
      this.setState({ showAddress: "null" });
    }
  };

  hideOfficialHistory = () => {
    this.setState({ historyVisible: false });
  };

  showOfficialHistory = () => {
    this.setState({ historyVisible: true });
  };

  openStatementVersion = async (data) => {
    const prevVersion = data.prevVersion ? await getStatementVersion(this.props.auth.startUrl, this.props.params.id, data.prevVersion.id, data.prevVersion.versionSnapshotId, this.props.dispatch) : null;
    const version = data.version ? await getStatementVersion(this.props.auth.startUrl, this.props.params.id, data.version.id, data.version.versionSnapshotId, this.props.dispatch) : null;
    this.props.dispatch(push({
      pathname: `${this.props.auth.startUrl}/funkcionari/${this.props.params.id}/oznameni/verze`,
      state: { statement: version, versionValidTo: data.validTo, prevVersion: prevVersion }
    }));
  };

  handleStatementInspectionResult = async (statementId, inspectionResult, forwardedTo, note) => {
    const { dispatch, url } = this.props;

    await createStatementInspectionResult(this.props.auth.startUrl, this.props.params.id, statementId, inspectionResult, forwardedTo, note)(this.props.dispatch);

    if (!isNil(url)) {
      this.setState({ statementUpdatePending: true });
      try {
        const response = await fetch(url, dispatch);
        const data = await response.json();
        const newChecked = data.checked || false;

        dispatch(change(FORM_NAME, "checked", newChecked));
      } catch (err) {}
      this.setState({ statementUpdatePending: false });
    }
  }

  handleWorkingPositionInspectionResult = async (workingPositionId, inspectionType, inspectionResult, periodYear, forwardedTo, note) => {
    const { dispatch, url, postProcess } = this.props;

    await createWorkingPositionInspectionResult(this.props.auth.startUrl, this.props.params.id, workingPositionId, inspectionType, inspectionResult, periodYear, forwardedTo, note)(this.props.dispatch);

    if (!isNil(url)) {
      this.setState({ workingPositionsUpdatePending: true });
      try {
        const response = await fetch(url, dispatch);
        const data = await response.json();
        const processedData = postProcess(data);
        const newPositions = processedData.workingPositions || [];
        const newChecked = processedData.checked || false;

        dispatch(change(FORM_NAME, "workingPositions", newPositions));
        dispatch(change(FORM_NAME, "checked", newChecked));
        dispatch(setItems(WP_GRID_NAME, {
          items: newPositions,
          allItems: newPositions,
          count: newPositions.length,
        }));

        dispatch(dataLoad(WP_GRID_NAME));
      } catch (err) {}
      this.setState({ workingPositionsUpdatePending: false });
    }
  }

  handleInspectionOpen = (inspectionId) => {
    const { auth, params } = this.props;
    this.props.dispatch(push(`${auth.startUrl}/funkcionari/${params.id}/kontroly/${inspectionId}`));
  }

  render() {
    const {
      error,
      onSubmit,
      onSave,
      onAppeal,
      submitting,
      onWPAdd,
      onRemoveWP,
      generateHandoverProtocol,
      auth,
      judge,
      locked,
      loadedEmail,
      hasRequestStatement,
      hasSecretStatement,
      displayDOSCheckbox,
      onChecked
    } = this.props;
    const {
      statements,
      workingPositions,
      canListStatements,
      statementsUrl,
      statementClick,
      wpClick,
      loginData,
      visibility,
      params,
      isNew,
      isMy,
      onStatementAdd,
      username,
      password,
      isEdited,
      permanentAddress,
      permanentAddressUpdateDate,
      canGeneratePassword,
      canDisplayCredentials,
      onUnarchive,
      aifo,
      checked,
      downloadDigitalActCertificate,
      deathDate,
    } = this.props;
    const ovmAddingNew = isNew && isOvm(auth);
    //u funkcionáře se zapsaným datem úmrtí nelze zapsat novou funkci, editace zůstává
    const deceased = !!deathDate;
    //const disabled = this.props.disabled || locked || (isMy === false);

    const disabled =
      this.props.disabled || (isInternal(auth) && !isOfficialAdmin(auth));
    const disabledExceptFunc = this.props.disabled || locked || this.state.loadingExistingOfficial;
    const o = enumOnCondition(isOvm(auth));
    const WorkPositionGridComponent = isOvm(auth) || isLegitimate(auth) ? WorkPositionGridWithOvmName : (isOfficialAdmin(auth) || isAdmin(auth) ? WorkPositionGridInternal : WorkingPositionGrid);
    const StatementGridInternalComponent = isInternal(auth) && (isOfficialAdmin(auth) || isAdmin(auth)) ? StatementGridAllAdminForOfficialDetail : StatementGridInternal;
    const StatementGridRozpracovaneComponent = (isOfficialAdmin(auth) || isAdmin(auth)) ? StatementGridRozpracovaneAllAdmin : StatementGridRozpracovane;

    if (isNotLogged(auth) || isOvm(auth) || isPublic(auth)) {
      return (
        <form
          onSubmit={this.save()}
          className="cro-form officialForm officialForm--public"
        >
          <div className="officialForm__section">
            <div className="officialForm__grid">
              <CroField
                className="third"
                title="Titul před"
                name="titleBefore"
                component={Input}
                disabled={disabled}
              />
              <CroField
                className="third"
                title="Jméno"
                name="firstName"
                component={Input}
                disabled={disabled || disabledExceptFunc}
                validate={[V.required, V.textSpaceDashOnly, V.noSpaceStartEnd]}
                onChange={
                  ovmAddingNew ? this.existingOfficial("firstName") : undefined
                }
              />
              <CroField
                className="third"
                title="Další jména"
                name="middleName"
                component={Input}
                disabled={disabled || disabledExceptFunc}
              />
              <CroField
                className="third"
                title="Příjmení"
                name="lastName"
                component={Input}
                disabled={disabled || disabledExceptFunc}
                validate={[V.required, V.textSpaceDashOnly, V.noSpaceStartEnd]}
                onChange={
                  ovmAddingNew ? this.existingOfficial("lastName") : undefined
                }
              />
              <CroField
                className="third"
                title="Titul za"
                name="titleAfter"
                component={Input}
                disabled={disabled}
              />
              {isOvm(auth) && (
                <CroField
                  className="third"
                  title="Datum narození"
                  name="birthDate"
                  component={DatePicker}
                  noIcon
                  disabled={disabled || disabledExceptFunc}
                  validate={[V.required, V.beforeToday]}
                  onChange={
                    ovmAddingNew
                      ? this.existingOfficial("birthDate")
                      : undefined
                  }
                />
              )}

              {isOvm(auth) && (
                <CroCountry
                  className="third"
                  title="Stát narození"
                  name="birthAddress"
                  disabled={disabled}
                  form={FORM_NAME}
                  validate={[V.required]}
                  helpEnum={o(H.OVM_BIRTH_COUNTRY.r)}
                />
              )}
              {isOvm(auth) && (
                <CroMunicipality
                  className="third compact-input"
                  title="Obec narození"
                  name="birthAddress"
                  disabled={disabled}
                  form={FORM_NAME}
                  validate={[V.required]}
                  helpEnum={o(H.OVM_BIRTH_MUNICIPALITY.r)}
                />
              )}

              {isOvm(auth) && !isNew && (
                  <CroField
                      className="third"
                      title="Datum úmrtí"
                      name="deathDate"
                      component={DatePicker}
                      validate={[V.beforeToday]}
                      noIcon
                      disabled={this.state.loadingExistingOfficial}
                      onChange={(value) => {
                        if(ovmAddingNew) {
                          this.existingOfficial("deathDate");
                        }
                        this.onChangeDeathDate(value);
                      }}
                  />
              )}

              {/* E-mail smí měnit každý OVM funkcionáře; existující e-mail nejde smazat, jen upravit
                  (u nového funkcionáře je povinný, u převzatého/editovaného podle načtené hodnoty). */}
              {isOvm(auth) &&
                ((isNew && !locked) || loadedEmail || this.state.adoptedEmailPresent ? (
                  <CroField
                    className="third compact-input"
                    title="E-mail"
                    name="email"
                    component={Input}
                    disabled={disabled}
                    validate={[V.required, V.email]}
                    hintText="@"
                  />
                ) : (
                  <CroField
                    className="third compact-input"
                    title="E-mail"
                    name="email"
                    component={Input}
                    disabled={disabled}
                    validate={[V.email]}
                    hintText="@"
                  />
                ))}

              {isOvm(auth) && (!!canGeneratePassword || !!canDisplayCredentials) && !(isNew && locked) && (
                <CroField
                  className="third"
                  title="Přihlašovací jméno"
                  name="username"
                  component={Input}
                  disabled={true}
                />
              )}
              {isOvm(auth) && (!!canGeneratePassword || !!canDisplayCredentials) && !(isNew && locked) && (
                <CroField
                  className="third"
                  title="Heslo"
                  name="plainPassword"
                  component={Password}
                  disabled={true}
                  alwaysShowEye={true}
                />
              )}

              {isOvm(auth) && !!canGeneratePassword && !(isNew && locked) && (
                <div className="third"></div>
              )}

              {isOvm(auth) &&
                (displayDOSCheckbox || this.checkWPsForSenatorOrDeputy()) && (
                  <CroField
                    className="half"
                    labelStyle={{ flexBasis: "auto" }}
                    title="Slib složen – do 31. 8. 2017 (včetně)"
                    name="promiseDocumented"
                    component={Checkbox}
                    disabled={true}
                  />
                )}

              {isOvm(auth) && (
                <CroField
                  className="half"
                  title="Ztotožněno"
                  name="checkedISZR"
                  component={Checkbox}
                  disabled={true}
                />
              )}
            </div>
          </div>

          {isOvm(auth) && ovmAddingNew && locked && isMy && (
            <p className="full">
              Tento veřejný funkcionář již byl zapsán tímto podpůrným orgánem.
            </p>
          )}

          {isOvm(auth) &&
            ((isMy === false && !ovmAddingNew) ||
              (ovmAddingNew && locked && isMy === false)) && (
              <p className="full">
                Tento veřejný funkcionář již byl zapsán jiným podpůrným orgánem,
                editujte jen obecné údaje a Vámi zapsanou funkci.
              </p>
            )}

          {(isOvm(auth) || isPublic(auth)) && ( //wps ovm
            <div className="officialForm__section officialForm__fullWidth">
              <CroLabeledCmp
                title="Funkce"
                required
                divStyle={{ width: "100%" }}
              >
                <WorkPositionGridComponent
                  gridName={WP_GRID_NAME}
                  items={workingPositions}
                  adding={(!disabledExceptFunc || ovmAddingNew) && !deceased}
                  onAdd={onWPAdd}
                  filtering={false}
                  deleting={false}
                  onRemove={onRemoveWP}
                  onRowClick={isPublic(auth) ? noop : wpClick}
                  ovmId={this.props.ovmId}
                  allowCheckAll={false}
                  canNotOpen={isPublic(auth)}
                  showDeadlines={isOvm(auth)}
                  generateHandoverProtocol={isOvm(auth) && !isNew ? generateHandoverProtocol : noop}
                  gridTooltips={isOvm(auth) ? { top: "Předávací protokol s vyrozuměním o zápisu zahájení/ukončení výkonu funkce naleznete pod ikonou u data konkrétního zápisu." } : null}
                />
              </CroLabeledCmp>
            </div>
          )}
          {isNotLogged(auth) && ( //wps public
            <div className="officialForm__section officialForm__fullWidth">
              <CroLabeledCmp title="Funkce" divStyle={{ width: "100%" }}>
                <WorkingPositionGrid
                  gridName={WP_GRID_NAME}
                  items={workingPositions}
                  filtering={false}
                  canNotOpen
                />
              </CroLabeledCmp>
            </div>
          )}

          {isLogged(auth) &&
            isOvm(auth) &&
            !judge && ( //statements for ovm
              <div className="officialForm__section officialForm__fullWidth">
                <CroLabeledCmp title="Oznámení" divStyle={{ width: "100%" }}>
                  {statements.length > 0 ? (
                    <StatementGridOvm
                      gridName="statementsGrid"
                      items={statements}
                      filtering={false}
                      onRowClick={noop}
                      canNotOpen
                      secondarySort={"updated"}
                      downloadDigitalActCertificate={downloadDigitalActCertificate}
                    />
                  ) : (
                    <p>Nenalezeno žádné oznámení.</p>
                  )}
                </CroLabeledCmp>
              </div>
            )}

          {(isNotLogged(auth) || (isLogged(auth) && isPublic(auth))) &&
            statements.length > 0 &&
            !judge && ( //statements public (not empty)
              <div className="officialForm__section officialForm__fullWidth">
                <CroLabeledCmp
                  title="Oznámení"
                  divStyle={{ width: "100%" }}
                  rowStyles={{ flexWrap: "wrap" }}
                >
                  <StatementGridPublic
                    gridName="statementsGrid"
                    items={statements}
                    filtering={false}
                    onRowClick={statementClick}
                    secondarySort={"updated"}
                  />
                  {hasSecretStatement && (
                    <p style={{ marginBottom: 0 }}>
                      Na tajná oznámení nelze nahlížet ani na základě žádosti
                      podle zákona o střetu zájmů ani na základě zákona
                      upravujícího svobodný přístup k informacím.
                    </p>
                  )}
                  {hasRequestStatement && !this.state.publicCanSeeSatements && (
                    <p style={{ paddingTop: 10, width: "100%" }}>
                      Některá oznámení nejsou veřejná. Lze prohlížet až po
                      vyřízení žádosti o nahlédnutí.
                    </p>
                  )}
                  {this.state.publicCanSeeSatements && (
                    <div style={{ paddingBottom: 30 }}></div>
                  )}{" "}
                  {/*space under the grid*/}
                </CroLabeledCmp>
              </div>
            )}

          {((isLogged(auth) && isPublic(auth)) || isNotLogged(auth)) &&
            statements.length === 0 && ( //statements public (empty or not accessible)
              <div className="officialForm__section officialForm__fullWidth">
                <CroLabeledCmp title="Oznámení">
                  <p>Nenalezeno žádné oznámení.</p>
                </CroLabeledCmp>
              </div>
            )}

          {isInternal(auth) && (
            <CroField
              className="full xl"
              title="Hlavní podpůrný orgán"
              name="settings.mainOvm"
              component={OvmAutoComplete}
              fullWidth
              disabled={disabled}
              url={`/api/ciselniky/ovm/official/${params.id}`}
              validate={[V.isDictionary]}
              onKeyDown={this.onKeyDown}
            />
          )}

          {(!disabledExceptFunc || ovmAddingNew) && (
            <div className="officialForm__footer">
              <div className="officialForm__footerInner">
                {error && <div className="error">{error}</div>}
                {!this.props.valid && this.props.submitFailed && !error && (
                  <div className="error">
                    Povinná pole nejsou správně vyplněna.
                  </div>
                )}
                <div className="officialForm__hint">
                  Povinná pole jsou označena hvězdičkou.
                </div>

                <div className="officialForm__actions">
                  <Button
                    type="button"
                    style={styles.buttons}
                    label="Uložit"
                    disabled={
                      submitting || (disabledExceptFunc && !ovmAddingNew)
                    }
                    onClick={this.save(onSave || onSubmit)}
                  />
                  <Button
                    type="button"
                    style={styles.buttons}
                    label="Zpět"
                    disabled={submitting}
                    onClick={() => this.props.router.goBack()}
                  />

                  {isOvm(auth) &&
                    !disabled &&
                    !!canGeneratePassword &&
                    !(isNew && locked) && (
                      <Button
                        type="button"
                        style={{ ...styles.buttons, marginTop: 3 }}
                        label="Generovat jméno a heslo"
                        disabled={submitting || disabled || this.disableGen()}
                        onClick={this.generateLogin(loginData)}
                        helpEnum={o(H.OVM_BTN_GENERATE.r)}
                        tooltipPosition="top-right"
                      />
                    )}
                  {this.props.onShowHistory && (
                    <Button
                      type="button"
                      style={styles.buttons}
                      label="Zobrazit historii"
                      onClick={this.props.onShowHistory}
                    />
                  )}
                </div>
              </div>
            </div>
          )}
          {isNotLogged(auth) && (
            <div className="officialForm__actions">
              <Button
                type="button"
                style={styles.buttons}
                label="Zpět"
                onClick={() => this.props.router.goBack()}
              />
              {hasRequestStatement && (
                <Button
                  type="button"
                  style={styles.buttons}
                  label="Žádost o nahlížení na neveřejné oznámení"
                  onClick={() =>
                    this.props.dispatch(
                      push({
                        pathname: "/verejnost/zadost",
                        query: { f: params.id },
                      }),
                    )
                  }
                />
              )}

              {!judge && (
                <Button
                  type="button"
                  style={styles.buttons}
                  label="Podat podnět"
                  onClick={() =>
                    this.props.dispatch(
                      push({
                        pathname: "/verejnost/podnet",
                        query: { f: params.id },
                      }),
                    )
                  }
                />
              )}
            </div>
          )}
          {isPublic(auth) && visibility === VisibilityRaw.REQUEST && (
            <div className="officialForm__actions">
              <Button
                type="button"
                style={styles.buttons}
                label="Žádost o nahlížení na neveřejné oznámení"
                onClick={() =>
                  this.props.dispatch(
                    push({
                      pathname: "/verejnost-prihlasen/zadosti/form",
                      query: { f: params.id },
                    }),
                  )
                }
              />
            </div>
          )}

          {this.state.infoDialog && this.state.infoDialog.open && (
              <Dialog open={true}
                      onClose={this.closeInfoDialog}
                      onKeyDown={(e) => e.stopPropagation()}
                      onClick={(e) => e.stopPropagation()}
                      maxWidth="sm"
                      fullWidth>
                <DialogContent>
                  { this.state.infoDialog.text }
                </DialogContent>
                <DialogActions style={{gap: 12, padding: '8px 24px 16px'}}>
                  <Button
                      type="button"
                      style={styles.buttons}
                      label="Rozumím"
                      onClick={this.closeInfoDialog}
                  />
                </DialogActions>
              </Dialog>
          )}
        </form>
      );
    }

    return (
      <form
        onSubmit={this.save()}
        className="cro-form officialForm officialForm--internal"
      >
        <div className="officialForm__section">
          <div className="officialForm__grid">
            <CroField
              className="third"
              title="Titul před"
              name="titleBefore"
              component={Input}
              disabled={disabled}
            />
            <CroField
              className="third"
              title="Jméno"
              name="firstName"
              component={Input}
              disabled={disabled}
              validate={[V.required, V.textSpaceDashOnly, V.noSpaceStartEnd]}
            />
            <CroField
              className="third"
              title="Další jména"
              name="middleName"
              component={Input}
              disabled={disabled}
            />

            <CroField
              className="third"
              title="Příjmení"
              name="lastName"
              component={Input}
              disabled={disabled}
              validate={[V.required, V.textSpaceDashOnly, V.noSpaceStartEnd]}
            />
            <CroField
              className="third"
              title="Titul za"
              name="titleAfter"
              component={Input}
              disabled={disabled}
            />
            <CroField
              className="third"
              title="Číslo OP"
              name="idCardNumber"
              component={Input}
              disabled={disabled}
              validate={[minLength5]}
            />

            <CroField
              className="third"
              title="Datum narození"
              name="birthDate"
              component={DatePicker}
              noIcon
              disabled={disabled}
              validate={[V.required, V.beforeToday]}
            />
            <CroCountry
              className="third"
              title="Stát narození"
              name="birthAddress"
              disabled={disabled}
              form={FORM_NAME}
              validate={[V.required]}
            />
            <CroMunicipality
              className="third compact-input"
              title="Obec narození"
              name="birthAddress"
              disabled={disabled}
              form={FORM_NAME}
              validate={[V.required]}
            />

            {isInternal(auth) && !isNew && (
              <CroField
                className="third"
                title="Datum úmrtí"
                name="deathDate"
                component={DatePicker}
                validate={[V.beforeToday]}
                noIcon
                disabled={disabled}
                onChange={this.onChangeDeathDate}
              />
            )}

            {!isLegitimate(auth) && (
              <CroField
                className="third"
                title="Přihlašovací jméno"
                name="username"
                component={Input}
                disabled={disabled}
                validate={[V.required]}
              />
            )}
            {!isLegitimate(auth) && !(!isNil(username) && isNil(password)) && (
              <CroField
                className="third"
                title="Heslo"
                name="plainPassword"
                component={Password}
                disabled={disabled}
                validate={[V.required, minLength8]}
                alwaysShowEye
              />
            )}
            {!isLegitimate(auth) && !isNil(username) && isNil(password) && (
              <div
                className="third"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                }}
              >
                Heslo změněno žadatelem.
              </div>
            )}
          </div>
        </div>
        {/* {!isLegitimate(auth) && <div className="third"></div>} */}

        {isInternal(auth) && (
          <div className="officialForm__section">
            <div className="officialForm__grid">
              {this.checkWPsForSenatorOrDeputy() && (
                <CroField
                  className="half"
                  labelStyle={{ flexBasis: "auto" }}
                  title="Slib složen – do 31. 8. 2017 (včetně)"
                  name="promiseDocumented"
                  component={Checkbox}
                  disabled={true}
                />
              )}
              <CroField
                className="third"
                title="Zkontrolován"
                name="checked"
                component={Checkbox}
                disabled={true}
              />
              <CroField
                className="third"
                title="Ztotožněn"
                name="aifo"
                component={Checkbox}
                disabled={disabled}
              />
            </div>
          </div>
        )}

        {isEdited && (
          <div className="officialForm__section officialForm__fullWidth">
            <CroSubhead title="Adresa trvalého bydliště" />

            {!isNil(permanentAddress) && (
              <>
                <div
                  style={{ paddingTop: 14, paddingBottom: 10, color: "black" }}
                >
                  Datum poslední aktualizace:{" "}
                  {moment(permanentAddressUpdateDate).format("DD.MM.YYYY")}
                </div>

                <div className="officialForm__grid">
                  <CroCountry
                    className="half"
                    title="Stát"
                    name="permanentAddress"
                    form={FORM_NAME}
                    disabled={true}
                  />
                  <CroMunicipality
                    className="half compact-input"
                    title="Obec"
                    name="permanentAddress"
                    form={FORM_NAME}
                    disabled={true}
                  />
                  <CroField
                    className="half"
                    title="Ulice"
                    name="permanentAddress.street"
                    component={Input}
                    disabled={true}
                  />
                  <CroField
                    className="half"
                    title="Č.p./Č.o."
                    name="permanentAddress.orientationNumber"
                    component={Input}
                    disabled={true}
                    helpEnum={H.HOUSE_NUMBER.r}
                  />
                  <CroField
                    className="half"
                    title="PSČ"
                    name="permanentAddress.zip"
                    component={Input}
                    disabled={true}
                  />
                </div>
                <div className="officialForm__grid" style={{paddingBottom: 14, paddingTop: 50}}>
                  <CroField
                      className="half"
                      title="ORP"
                      name="permanentAddress.orp"
                      component={Input}
                      form={FORM_NAME}
                      disabled={true}
                  />
                </div>
              </>
            )}

            {this.state.showAddress === "null" && (
              <div style={{ paddingTop: 14, color: "#000000" }}>
                Nepodařilo se získat adresu trvalého bydliště.
              </div>
            )}

            {!isLegitimate(auth) && (
              <Button
                type="button"
                style={styles.buttons}
                label={isNil(permanentAddress) ? "Získat" : "Aktualizovat"}
                disabled={submitting}
                onClick={this.showAddress}
              />
            )}
          </div>
        )}
        <div className="officialForm__section">
          <CroSubhead title="Adresa pro doručování" />
          <div className="officialForm__grid">
            <CroField
              className="half"
              title="Datová schránka"
              name="databox"
              component={Input}
              disabled={disabled}
            />
            {loadedEmail ? (
              <CroField
                className="half compact-input"
                title="E-mail"
                name="email"
                component={Input}
                disabled={disabled}
                validate={[V.required, V.email]}
                hintText="@"
              />
            ) : (
              <CroField
                className="half compact-input"
                title="E-mail"
                name="email"
                component={Input}
                disabled={disabled}
                validate={[V.email]}
                hintText="@"
              />
            )}

            <CroCountry
              className="half"
              title="Stát"
              name="deliveryAddress"
              disabled={disabled}
              form={FORM_NAME}
            />
            <CroMunicipality
              className="half compact-input"
              title="Obec"
              name="deliveryAddress"
              disabled={disabled}
              form={FORM_NAME}
            />

            <CroField
              className="half"
              title="Ulice"
              name="deliveryAddress.street"
              component={Input}
              disabled={disabled}
            />
            <CroField
              className="half"
              title="Č.p./Č.o."
              name="deliveryAddress.orientationNumber"
              component={Input}
              disabled={disabled}
              helpEnum={H.HOUSE_NUMBER.r}
            />

            <CroField
              className="half"
              title="PSČ"
              name="deliveryAddress.zip"
              component={Input}
              disabled={disabled}
            />
          </div>
        </div>

        {isInternal(auth) && !this.state.loading && (
          <div className="officialForm__section officialForm__fullWidth">
            <CroLabeledCmp title="Funkce" divStyle={{ width: "100%" }}>
              <WorkPositionGridComponent
                gridName={WP_GRID_NAME}
                items={workingPositions}
                adding={false}
                filtering={false}
                deleting={isOfficialAdmin(auth)}
                onRemove={onRemoveWP}
                onRowClick={wpClick}
                onWorkingPositionInspectionResult={this.handleWorkingPositionInspectionResult}
                onInspectionEdit={this.handleInspectionOpen}
                administrativeAutorities={this.state.administrativeAutorities}
                showDeadlines
              />
            </CroLabeledCmp>
          </div>
        )}
        {!isInternal(auth) && (
          <div className="officialForm__section officialForm__fullWidth">
            <CroLabeledCmp title="Funkce" divStyle={{ width: "100%" }}>
              <WorkPositionGridComponent
                gridName={WP_GRID_NAME}
                items={workingPositions}
                filtering={false}
              />
            </CroLabeledCmp>
          </div>
        )}

        {statements.length !== 0 && !judge && !this.state.statementUpdatePending && !this.state.loading && (
            <div className="officialForm__section officialForm__fullWidth">
              <CroLabeledCmp title="Oznámení">
                <StatementGridInternalComponent
                    gridName="statementsGrid"
                    items={statements}
                    showLoading={true}
                    filtering={false}
                    onRowClick={statementClick}
                    sort={"creationDate"}
                    secondarySort={"updated"}
                    auth={auth}
                    onMasterDetailOpen={this.openStatementVersion}
                    onStatementInspectionResult={this.handleStatementInspectionResult}
                    onInspectionEdit={this.handleInspectionOpen}
                    administrativeAutorities={this.state.administrativeAutorities}
                    downloadDigitalActCertificate={downloadDigitalActCertificate}
                />
              </CroLabeledCmp>
            </div>
        )}
        {canListStatements && !isNew && !this.state.statementUpdatePending && !this.state.loading && (
            <div className="officialForm__section officialForm__fullWidth">
              <CroLabeledCmp title="Oznámení">
                <StatementGridInternalComponent
                    gridName={statementsUrl}
                    url={statementsUrl}
                    items={this.state.items}
                    showLoading={true}
                    onRowClick={statementClick}
                    adding={!disabled && isOfficialAdmin(auth)}
                    onAdd={onStatementAdd(auth.startUrl)}
                    deleting={isOfficialAdmin(auth)}
                    onRemove={
                      isOfficialAdmin(auth) ? this.onRemoveStatements : noop
                    }
                    sort={"creationDate"}
                    secondarySort={"updated"}
                    auth={auth}
                    onMasterDetailOpen={this.openStatementVersion}
                    onStatementInspectionResult={this.handleStatementInspectionResult}
                    onInspectionEdit={this.handleInspectionOpen}
                    administrativeAutorities={this.state.administrativeAutorities}
                    downloadDigitalActCertificate={downloadDigitalActCertificate}
                />
              </CroLabeledCmp>
            </div>
        )}

        {SHOW_ESM_SECTION && (isOfficialAdmin(auth) || isAdmin(auth)) && !isNew && (
          <div className="officialForm__section officialForm__fullWidth">
            <CroLabeledCmp
              title="Evidence skutečných majitelů"
              divStyle={{ width: "100%" }}
            >
              <EsmEntriesSection
                auth={auth}
                officialId={params.id}
                dispatch={this.props.dispatch}
                disabled={this.props.disabled}
              />
            </CroLabeledCmp>
          </div>
        )}

        {canListStatements && !isNew && this.state.rozpracovaneCount > 0 && !this.state.statementUpdatePending && (
            <div className="officialForm__section officialForm__fullWidth">
              <CroLabeledCmp title="Rozpracovaná oznámení" divStyle={{ width: "100%" }}>
                <StatementGridRozpracovaneComponent
                    gridName={`${statementsUrl}/rozpracovane`}
                    url={`${statementsUrl}/rozpracovane`}
                    items={this.state.items}
                    onRowClick={(row) => statementClick(row)}
                    sort={"created"}
                    secondarySort={"updated"}
                />
              </CroLabeledCmp>
            </div>
        )}

        {isInternal(auth) && (
          <CroField
            className="full xl"
            title="Hlavní podpůrný orgán"
            name="settings.mainOvm"
            component={OvmAutoComplete}
            fullWidth
            disabled={disabled}
            url={`/api/ciselniky/ovm/official/${params.id}`}
            validate={[V.isDictionary]}
            onKeyDown={this.onKeyDown}
          />
        )}

        {isInternal(auth) && (
          <CroField
            className="full"
            title="Viditelnost"
            name="visibility"
            component={Select}
            items={Visibility}
            disabled={disabled}
            fullWidth
          />
        )}

        <div className="officialForm__footer">
          <div className="officialForm__footerInner">
            {error && <div className="error">{error}</div>}
            {!this.props.valid && this.props.submitFailed && !error && (
              <div className="error">Povinná pole nejsou správně vyplněna.</div>
            )}
            {!disabled && (
              <div className="officialForm__hint">
                Povinná pole jsou označena hvězdičkou.
              </div>
            )}

            <div className="officialForm__actions">
              {!disabled && (
                <Button
                  type="button"
                  style={styles.buttons}
                  label="Uložit"
                  disabled={submitting || disabled}
                  onClick={this.save(onSave || onSubmit)}
                />
              )}
              <Button
                type="button"
                style={styles.buttons}
                label="Zpět"
                onClick={() => this.props.router.goBack()}
              />
              {this.props.onShowHistory && (
                <Button
                  type="button"
                  style={styles.buttons}
                  label="Zobrazit historii"
                  onClick={this.props.onShowHistory}
                />
              )}
              {isInternal(auth) &&
                this.props.isArchived &&
                this.props.isArchived.length > 0 && (
                  <Button
                    type="button"
                    style={styles.buttons}
                    label="Navrátit z archivovaných"
                    onClick={this.save(onUnarchive)}
                  />
                )}
              {isInternal(auth) && !isNew && (
                <DropdownButton
                  type="button"
                  style={styles.buttons}
                  label="Zaslat výzvu"
                  disabled={submitting}
                  options={this.state.functionaryNoticeTypes.map((type) => ({ label: type.name, value: type.id, onClick: () => { onAppeal(type.id) } })) }
                />
              )}
              {isInternal(auth) && !isNew && (
                <>
                  <DropdownButton
                      type="button"
                      style={styles.buttons}
                      label="K postoupení"
                      disabled={submitting}
                      options={this.state.forwardingReasons.map((reason) => {
                        return { label: reason.name,
                                 value: reason.id,
                                 onClick: () => {
                                  this.setState({
                                    forwardingDialogOpen: true,
                                    forwardingSelectedReason: reason,
                                  });
                                 }
                        };
                      })}
                  />
                  {!checked && onChecked && (
                    <Button
                        type="button"
                        style={styles.buttons}
                        label="Zkontrolován"
                        disabled={submitting}
                        onClick={onChecked}
                    />
                  )}
                </>
              )}
              {((isOfficialAdmin(auth) && !disabled) || isAdmin(auth)) && (
                <Button
                  type="button"
                  style={styles.buttons}
                  label="Generovat jméno a heslo"
                  disabled={submitting}
                  onClick={this.generateLogin(loginData)}
                />
              )}
            </div>
          </div>
        </div>
        <ForwardingClarifyingDialog
          open={this.state.forwardingDialogOpen}
          reason={this.state.forwardingSelectedReason}
          workingPositions={this.props.workingPositions || []}
          officialId={this.props.params.id}
          startUrl={this.props.auth?.startUrl}
          onCancel={() => this.setState({ forwardingDialogOpen: false })}
          onConfirm={(data) => {
            this.setState({ forwardingDialogOpen: false });
            if (this.props.onForwardOfficial) {
              this.props.onForwardOfficial({
                reason: this.state.forwardingSelectedReason,
                ...data,
              });
            }
          }}
        />

        {this.state.infoDialog && this.state.infoDialog.open && (
          <Dialog open={true}
                  onClose={this.closeInfoDialog}
                  onKeyDown={(e) => e.stopPropagation()}
                  onClick={(e) => e.stopPropagation()}
                  maxWidth="sm"
                  fullWidth>
            <DialogContent>
              { this.state.infoDialog.text }
            </DialogContent>
            <DialogActions style={{gap: 12, padding: '8px 24px 16px'}}>
              <Button
                  type="button"
                  style={styles.buttons}
                  label="Rozumím"
                  onClick={this.closeInfoDialog}
              />
            </DialogActions>
          </Dialog>
        )}
      </form>
    );
  }
}

const ConnectedForm = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
  initialValues: { allowBasic: true, allowDatabox: false },
})(askAction(OfficialForm));

export default class OfficialFormAdding extends Component {
  initialWP = {};

  static defaultProps = {
    postProcess: identity,
  };

  state = {
    locked: false,
    displayDOSCheckbox: false,
    ovmId: undefined,
    loadedEmail: false,
  };

  async componentDidMount() {
    const { url, postProcess, dispatch } = this.props;
    if (!isNil(url)) {
      dispatch(setLoading(true, "Načítání dat..."));
      const response = await fetch(url, dispatch);
      let initialValues = await response.json();

      if (isInternal(this.props.auth)) {
        const ovmResponse = await fetch(
          `${this.props.auth.startUrl}/api/podpurne-organy?filter[0].field=subject&filter[0].operation=CONTAINS&filter[0].value=${initialValues.settings.mainOvmName}&sort=subject&order=ASC&page=0&pageSize=100`,
          dispatch,
        );
        const ovmRes = await ovmResponse.json();
        initialValues["mainOvm"] = ovmRes.items[0];
      }

      let orp = await getOrp(
        dispatch,
        get(initialValues, "permanentAddress.municipalityId", ""),
      );
      if (orp !== "") {
        initialValues.permanentAddress.orp = orp;
      }
      initialValues.allowBasic = true;
      initialValues.allowDatabox = false;
      initialValues.originalWPs = get(initialValues, "workingPositions", 0);
      // Existující e-mail nesmí jít smazat, jen upravit (stejné pravidlo jako ChangeProfile).
      this.setState({
        loadedEmail: !isNil(initialValues.email) && String(initialValues.email).trim().length > 0,
      });
      this.props.dispatch(initialize(FORM_NAME, postProcess(initialValues)));
      this.props.dispatch(
        dataInit(WP_GRID_NAME, {
          items: initialValues.workingPositions,
          sort: "created",
          order: Order.DESC,
        }),
      );
      this.props.dispatch(dataLoad(WP_GRID_NAME));
      dispatch(setLoading());
    }

    if (isOvm(this.props.auth)) {
      const response = await fetch("/podpurny-organ/api/profil/ja", dispatch);
      const r = await response.json();
      const isDeputyOrSenator = r.isDeputyOrSenator;
      const ovmId = r.id;
      this.setState({ displayDOSCheckbox: isDeputyOrSenator, ovmId: ovmId });
    }
  }

  componentWillUnmount() {
    this.props.dispatch(destroy(FORM_NAME));
  }

  startAdding = () => {
    const { dispatch, location } = this.props;
    dispatch(
      push({ pathname: location.pathname, query: { q: "pridat-pozici" } }),
    );
  };

  stopAdding = () => {
    this.props.router.goBack();
  };

  onAddWP = async (wp) => {
    if (this.props.isNew) {
      this.props.dispatch(arrayPush(FORM_NAME, "workingPositions", wp));
      this.stopAdding();
      return;
    }
    
    const saved = await this.props.dispatch(
        saveWorkingPosition(this.props.auth.startUrl, this.props.params.id, wp)
    );
    this.props.dispatch(arrayPush(FORM_NAME, "workingPositions", saved));
    this.stopAdding();
  };

  onRemoveWP = (ids) => {
    const { auth, params, dispatch } = this.props;

    if(!isOfficialAdmin(auth)) {
      return;
    }

    deleteWorkingPosition(auth.startUrl, params.id, ids)(dispatch);

    this.props.workingPositions
      .map((item, index) => ({ index, id: item.id }))
      .filter((obj) => ids.includes(obj.id))
      .sort((a, b) => b.index - a.index) //descending
      .forEach((obj) =>
        this.props.dispatch(
          arrayRemove(FORM_NAME, "workingPositions", obj.index),
        ),
      );
  };

  wpClick = (wp) => {
    const { dispatch, location } = this.props;
    dispatch(
      push({ pathname: location.pathname, query: { q: "editovat-pozici" } }),
    );
    this.initialWP = wp;
  };

  stopEditing = () => {
    this.initialWP = {};
    this.props.router.goBack();
  };

  onEditWP = async (wp) => {
    const i = this.props.workingPositions.findIndex((w) => w.id === wp.id);

    if (this.props.isNew) {
      this.props.dispatch(arrayRemove(FORM_NAME, "workingPositions", i));
      this.props.dispatch(arrayInsert(FORM_NAME, "workingPositions", i, wp));
      this.stopEditing();
      return;
    }

    const saved = await this.props.dispatch(
        saveWorkingPosition(this.props.auth.startUrl, this.props.params.id, wp)
    );
    this.props.dispatch(arrayRemove(FORM_NAME, "workingPositions", i));
    this.props.dispatch(arrayInsert(FORM_NAME, "workingPositions", i, saved));
    this.stopEditing();
  };

  generateHandoverProtocol = async (wp, type) => {
    await generateHandoverProtocolOfficialWorkingPosition(this.props.params.id, wp.id, type, this.props.dispatch);
  };

  downloadDigitalActCertificate = async (statementId) => {
    await downloadStatementDigitalActCertificate(this.props.auth, statementId, this.props.dispatch);
  }

  statementClick = (data) => {
    const { auth, params } = this.props;
    const startUrl = isNotLogged(auth)
      ? "/verejnost"
      : isPublic(auth)
        ? "/verejnost-prihlasen"
        : auth.startUrl;
    if (data.canOpen === false) {
      return noop;
    } else {
      if ("statementId" in data && data.statementId.length > 0) {
        this.props.dispatch(
          push(
            `${startUrl}/funkcionari/${params.id}/oznameni/${data.statementId}`,
          ),
        );
      } else if ("id" in data && data.id.length > 0) {
        this.props.dispatch(
          push(`${startUrl}/funkcionari/${params.id}/oznameni/${data.id}`),
        );
      } else {
        return noop;
      }
    }
  };

  onStatementAdd = (url) => () => {
    const { params } = this.props;
    this.props.dispatch(push(`${url}/funkcionari/${params.id}/oznameni/form`));
  };

  lock = (bool) => {
    this.setState({ locked: bool });
  };

  render() {
    const {
      auth,
      params,
      location: { query },
      ovmIds,
    } = this.props;

    const enableWPEdit =
      (!isNil(this.initialWP.ovmId) &&
        !isNil(this.state.ovmId) &&
        this.initialWP.ovmId === this.state.ovmId) ||
      isOfficialAdmin(auth);

    const statementsUrl = `${auth.startUrl}/api/funkcionari/${params.id}/oznameni`;

    if (query.q === "pridat-pozici") {
      return (
        <WorkingPositionAddForm
          goBack={this.stopAdding}
          initialValues={{ id: uuid(), ovmId: this.state.ovmId }}
          onSubmit={this.onAddWP}
          auth={auth}
          ovmIds={ovmIds}
          disabled={!isOvm(auth)}
        />
      );
    }
    if (query.q === "editovat-pozici") {
      return (
        <WorkingPositionAddForm
          goBack={this.stopEditing}
          initialValues={this.initialWP}
          onSubmit={this.onEditWP}
          auth={auth}
          ovmIds={ovmIds}
          officialId={params.id}
          disabled={!enableWPEdit || (!isOvm(auth) && !isOfficialAdmin(auth))}
        />
      );
    }
    return (
      <ConnectedForm
        {...this.props}
        onWPAdd={this.startAdding}
        onRemoveWP={this.onRemoveWP}
        wpClick={this.wpClick}
        lock={this.lock}
        locked={this.state.locked}
        loadedEmail={this.state.loadedEmail}
        statementClick={this.statementClick}
        statementsUrl={statementsUrl}
        displayDOSCheckbox={this.state.displayDOSCheckbox}
        ovmId={this.state.ovmId}
        onStatementAdd={this.onStatementAdd}
        generateHandoverProtocol={this.generateHandoverProtocol}
        downloadDigitalActCertificate={this.downloadDigitalActCertificate}
      />
    );
  }
}
